import {MOST_POPULAR} from '~/constants/ArtCategoryConstants';
import remoteServices from '~/constants/RemoteServices';
import {INK_COLORS} from '~/constants/InkConstants';
import {isPureMagenta, isWhite} from '~/data/accessors/color';
import {buildUrl} from '~/utils/url';

const PURE_MAGENTA_COLOR_OBJECT = {
  red: 255,
  green: 0,
  blue: 255
};

export function buildSearchUrl({keyword}, all = false) {
  const params = {keyword, all};
  return buildUrl(`${remoteServices.clipart}/search.hal`, params);
}

export function buildCategoryUrl({cat}, all = false) {
  // either search for the most popular images
  if (Number(cat) === MOST_POPULAR.id) {
    return buildSearchUrl({keyword: MOST_POPULAR.keyword}, all);
  }

  // or load category from categories
  const folder = all ? 'browse' : 'clipart_categories';
  return buildUrl(`${remoteServices.clipart}/${folder}/${cat}.json`, {all});
}

export async function fetchClipartInfo(clipartId) {
  const clipartInfoUrl = buildUrl(`${remoteServices.clipart}/info`, {
    clipart_id: clipartId
  });
  const clipartVersionsUrl = `${remoteServices.clipart}/versions/${clipartId}`;
  return Promise.all([
    window.fetch(clipartInfoUrl),
    window.fetch(clipartVersionsUrl)
  ])
    .then(([info, clipart_versions]) =>
      Promise.all([info.json(), clipart_versions.json()])
    )
    .then(([info, clipart_versions]) => ({
      ...info,
      clipart_versions
    }))
    .catch(() => {
      throw new Error('Unable to fetch clipart metadata');
    });
}

export function mapClipartColorToRFE(color) {
  if (isWhite(color)) {
    return PURE_MAGENTA_COLOR_OBJECT;
  }

  return color;
}

export function mapClipartColorFromRFE(color) {
  if (isPureMagenta(color) || isWhite(color)) {
    return INK_COLORS.White;
  }

  return color;
}

export function makeWhiteColorTransparent(color) {
  return isWhite(color) ? INK_COLORS.None : color;
}

export function mapSpotColorToTransparent(spotColor) {
  return spotColor.set('user', makeWhiteColorTransparent(spotColor.original));
}
